import { IClientValidator } from "./IClientValidator.js";

    /// Works with MustBeCheckedAttribute.cs to perform unobtrusive validation in MVC against checkbox type
    /// input elements that must be ticked such as terms and conditions.
    export class MustBeChecked implements IClientValidator {
        public validate(value: string, element: HTMLInputElement, params: any): boolean {
            return element.checked;
        }
    }

window.validators = window.validators || {};
window.validators.mustbechecked = new MustBeChecked();
